module.exports = __webpack_public_path__ + "static/media/travel21.d4f6ec9f.jpg";